import * as React from 'react';
import { css } from 'aphrodite/no-important';
import Helmet from 'react-helmet';
import { MandatoryAdditionalStyle } from '../../components.utils';
import { ErrorBoundary } from '../../errorHandling/ErrorBoundary';

interface ApesterDataProps {
    html: string;
    dataId?: string;
}

export interface IframeThemeProps {
    backgroundColor: string;
}

type IframeComponentProps = ApesterDataProps & MandatoryAdditionalStyle;
export type IframeProps = ApesterDataProps & MandatoryAdditionalStyle;


export const Apester: React.FunctionComponent<IframeComponentProps> = props => {
  const { html, additionalStyle, dataId } = props;
  return (
    <ErrorBoundary>
      <Helmet>
        <script async defer src="https://static.apester.com/js/sdk/latest/apester-sdk.js" />
      </Helmet>
      <div className={css(additionalStyle.style)}>
        {/* eslint-disable-next-line react/no-danger */}
        <figure data-id={dataId} dangerouslySetInnerHTML={{ __html: html }} />
      </div>
    </ErrorBoundary>
  );
};
